// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import { CUPONERA_SEATS } from './constants';

export function setCuponeraSeats(data) {
  return {
    type: CUPONERA_SEATS,
    data: data,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CUPONERA_SEATS:
      return {
        ...state,
        cuponeraSeats: action.data,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/setCuponeraSeats.js